import React, { useEffect } from "react";
import BottomDialog from "./BottomDialog.js";
import CenterDialog from "./CenterDialog.js";
import { useDimensions } from "src/utils/useDimensions.js";
import NativeCheckout from "../checkouts/NativeCheckout.js";
import { Box } from "@mui/material";
import ConsumerUpgradeContent from "src/components/upgrades/consumer/ConsumerUpgradeContent.js";
import SocialProof from "src/components/upgrades/SocialProof.js";
import { customEvent } from "src/utils/gtag.js";

const NativeCheckoutDialog = ({ open, onClose, calendar, ...props }) => {
  const { isSmallScreen } = useDimensions();

  useEffect(() => {
    if (open) {
      customEvent({
        name: "landed_on_native_checkout_dialog",
        category: "Upgrade",
        label: "Landed on Native Checkout Dialog",
        data: {
          calendar_name: calendar?.name,
          calendar_id: calendar?._id,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleUpgradeClick = () => {
    const dialogContent = document.querySelector(".MuiDialogContent-root");
    if (dialogContent) dialogContent.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <>
      {isSmallScreen ? (
        <BottomDialog
          open={open}
          handleClose={onClose}
          sx={{ height: "90%" }}
          hideRectangle
          bubbleStyle
        >
          <SocialProof calendar={calendar} />
          <NativeCheckout key={open ? 'open' : 'closed'} {...props} />
          <ConsumerUpgradeContent handleUpgradeClick={handleUpgradeClick} />
        </BottomDialog>
      ) : (
        <CenterDialog
          open={open}
          handleClose={onClose}
          sx={{ height: "auto", ".MuiDialogContent-root": { mt: "60px" } }}
        >
          <Box
            sx={{
              width: "800px",
              maxWidth: "100%",
              minHeight: "380px",
              maxHeight: "600px",
            }}
          >
            <SocialProof calendar={calendar} />
            <NativeCheckout key={open ? 'open' : 'closed'} {...props} />
            <ConsumerUpgradeContent handleUpgradeClick={handleUpgradeClick} />
          </Box>
        </CenterDialog>
      )}
    </>
  );
};

export default NativeCheckoutDialog;
